import axios from 'axios'

let cloudURL = `https://yo-analytics.herokuapp.com`
let baseURL = cloudURL

// if (process.env.NODE_ENV === 'development') {
//   baseURL = `http://localhost:1337`
// }

export const getYoAnaylticsAxios = () => {
  var baseURL = `https://yo-analytics.herokuapp.com/`
  let headers = {
    // 'Authorization': `bearer ${State.jwt}`
  }
  return axios.create({
    withCredentials: false,
    baseURL,
    headers
  })
}

export const collectResp = ({ roomSize, roomName, displayName, userType, userID, gameID, resp, question, questionBankQuestionID, questionBankFolderID, questionBankFolderTagName, takeHowLongToAns, correct, ansDate, full, mark, gameType, questionType, levelOfQuestion, cellState, cellID, actionType }) => {
  let info = {
    roomSize,
    roomName,
    displayName,
    userID,
    userType,
    resp,
    question,
    questionBankQuestionID,
    questionBankFolderID,
    questionBankFolderTagName,
    takeHowLongToAns,
    correct,
    ansDate,
    full,
    mark,
    gameType,
    gameSessionID: gameID,
    questionType,
    levelOfQuestion,
    cellState,
    cellID,
    actionType
  }
  return axios.post(`${baseURL}/responses/`, info)
    .then((r) => {
      return r.data
    })
}

export const getCountCorrect = ({ userID, gameID }) => {
  let gameType = `cell-game`
  let correct = true
  let urlForCorrect = `${baseURL}/responses/count?gameType=${gameType}&gameSessionID=${gameID}&correct=${correct}&firebaseUserID=${userID}`

  return axios.get(urlForCorrect)
    .then((r) => {
      return r.data
    })
}

export const getCountIncorrect = ({ userID, gameID }) => {
  let gameType = `cell-game`
  let incorrect = false
  let urlForIncorrect = `${baseURL}/responses/count?gameType=${gameType}&gameSessionID=${gameID}&correct=${incorrect}&firebaseUserID=${userID}`

  return axios.get(urlForIncorrect)
    .then((r) => {
      return r.data
    })
}

// login join game
export const logJoinGame = ({ playerID, gameID, displayName }) => {
  let info = {
    playerID,
    gameID,
    displayName,
    roomEntryDate: new Date(),
    gameType: 'cell-game'
  }
  return axios.post(`${baseURL}/onlines/`, info)
    .then((r) => {
      return r.data
    })
}

export const getUserCorrectCount = ({ gameID, userID }) => {
  let gameType = `cell-game`
  let correct = true
  let url = `/responses/count?gameSessionID=${encodeURIComponent(gameID)}&gameType=${encodeURIComponent(gameType)}&userID=${userID}&correct=${correct}`
  return getYoAnaylticsAxios().get(url)
    .then((r) => {
      return r.data
    })
    .then(r => {
      return r
    })
}

export const getUserAttemptCount = ({ gameID, userID }) => {
  let gameType = `cell-game`
  let url = `/responses/count?gameSessionID=${encodeURIComponent(gameID)}&gameType=${encodeURIComponent(gameType)}&userID=${userID}`
  return getYoAnaylticsAxios().get(url)
    .then((r) => {
      return r.data
    })
    .then(r => {
      return r
    })
}

// export const getRangedResponse = ({ newBaseURL = cloudURL, gameID, perPage = 100, pageAt = 0, dateStart, dateEnd }) => {
//   let gameType = `cell-game`
//   let url = `${newBaseURL}/responses?gameSessionID=${encodeURIComponent(gameID)}&gameType=${encodeURIComponent(gameType)}&_limit=${perPage}&_start=${perPage * pageAt}&ansDate_gte=${encodeURIComponent(dateStart)}&ansDate_lte=${encodeURIComponent(dateEnd)}`
//   return axios.get(url)
//     .then((r) => {
//       return r.data
//     })
//     .then(r => {
//       return r
//     })
// }
